var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{attrs:{"colspan":_vm.colspan,"rowspan":_vm.rowspan}},[_c('v-skeleton-loader',{attrs:{"type":"table-tbody"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }